export default {
  settings: {
    title: 'Pengaturan',
    account_related: 'Informasi akun',
    // user_related: "",
    add_user_title: 'Tambah Pengguna',
    edit_user_title: 'Edit Pengguna',
    label: {
      enabled: 'Diaktifkan',
      not_set: 'Tidak diatur',
    },
    company: {
      title: 'Informasi Perusahaan',
      name: 'Nama Perusahaan',
      english_name: 'English name',
      scale: 'Jumlah karyawan',
      industry_type: 'Industri',
      plan: 'Paket',
      location: 'Alamat',
      allowed_ip: 'Alamat IP yang Diizinkan',
      mfa: 'Autentikasi SMS',
      sales_amount: 'Pendapatan',
      country: 'Negara',
    },
    contract_plans: {
      buyer: 'Rencana pembeli',
      supplier: 'Rencana pemasok',
    },
    user: {
      title: 'Daftar Pengguna',
      name: 'Nama',
      first_name: 'Nama Belakang',
      last_name: 'Nama Depan',
      email: 'Alamat email',
      email_unverified: 'Sebelum pendaftaran',
      password: 'Kata sandi',
      password_protection: 'Disembunyikan untuk tujuan keamanan',
      phone_number: 'Nomor telepon',
      role: {
        title: 'Izin',
        admin: 'Admin',
        general: 'Umum',
      },
      locale: 'Pilih Bahasa',
      action: 'Pengoperasian',
      total: 'Semua: {total}(Maks.: {max})',
    },
    button: {
      create: 'Tambah Pengguna',
      edit: '@:common.btn.edit',
      cancel: '@:common.btn.cancel',
      close: '@:common.btn.close',
      add: '@:common.btn.add',
      update: '@:common.btn.update',
      delete: '@:common.btn.delete',
      do_delete: '@:common.btn.delete',
      reset_password: '@:forgot_password.title',
    },
    cautions_title: 'Pemberitahuan',
    cautions_01: 'Anda tidak dapat mengubah alamat email Anda. Untuk mengatur ulang email Anda, silakan buat pengguna baru.',
    cautions_02: 'Nomor telepon diperlukan jika autentikasi SMS diaktifkan.',
    cautions_03: 'Untuk mengatur ulang kata sandi Anda, masukkan kode verifikasi yang dikirim ke alamat email Anda yang terdaftar ke layar pengaturan ulang kata sandi.',
    cautions_04: 'Menghapus pengguna tidak menghapus data jawaban atau kartu skor.',
    messages: {
      user_update: 'Perbarui informasi pengguna',
      user_delete: 'Hapus pengguna',
      confirm_delete: 'Anda ingin menghapus pengguna ini?',
      // complete_create: "",
      complete_update: 'Informasi pengguna telah diperbarui.',
      complete_delete: 'Penghapusan informasi pengguna telah selesai.',
      disabled_delete: 'Setidaknya satu pengguna harus memiliki otoritas "Admin".',
      disabled_delete_by_auth: 'Hanya Admin yang dapat menghapus.',
      invalid_form: 'Input Salah.',
      caution_title: '@:list_table_filter.csv_modal_cautionary_note_title',
      caution_one: 'Setelah mengeklik "TAMBAHKAN", email konfirmasi akan dikirim ke alamat email yang Anda masukkan. \nSelanjutnya, email yang berisi ID login dan kata sandi Anda akan dikirim.',
      caution_two: 'Nomor telepon diperlukan jika autentikasi SMS diaktifkan.',
      caution_three: 'Dapat menambahkan hingga 5 pengguna.',
      user_add_title: 'Tambah Pengguna',
      user_add_message_one: 'Kami telah mengirim email ke alamat yang Anda berikan. ',
      user_add_message_two: 'Silakan periksa email Anda dan ikuti petunjuk dalam email untuk login.',
    },
    tips: {
      role: 'Otoritas "Admin" dapat menambah dan menghapus pengguna, tetapi otoritas "Umum" tidak dapat melakukannya.',
      locale: 'Anda dapat memilih pengaturan bahasa awal setelah masuk.',
    },
    // english_name_edit_modal_title: "",
    // english_name_input_label: "",
    // english_name_placeholder: "",
    reset_password: {
      title: '@:forgot_password_submit.title',
      content: 'Anda yakin ingin keluar dan membuka halaman pengaturan ulang kata sandi? Pada halaman pengaturan ulang kata sandi, masukkan kode verifikasi yang diberikan dalam email yang dikirim ke alamat email Anda yang terdaftar.',
      reset: 'Atur Ulang Kata Sandi',
    },
  },
}
